import { render, staticRenderFns } from "./accidentDetails.vue?vue&type=template&id=434aa770&scoped=true"
import script from "./accidentDetails.vue?vue&type=script&lang=js"
export * from "./accidentDetails.vue?vue&type=script&lang=js"
import style0 from "./accidentDetails.vue?vue&type=style&index=0&id=434aa770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434aa770",
  null
  
)

export default component.exports